export const SET_CURRENT_PAGE = "storeCurrentPageData";
export const CURRENT_PAGE_ERROR = "currenPageError";
export const SET_PRELOADER_LOADED = "setPreloaderLoaded";

// job mutation
export const SET_JOB_DATA = "setJobData";
export const SET_JOB_DATA_ERROR = "SetJobDataError";
export const SET_JOB_CURRENT_PAGE = "setJobCurrentPage";
export const SET_JOB_PARENT_PAGE = "setJobParentPage";

export const ADD_ANIMATION = "addMainTimeLineAnimation";
// banner mutation
export const SET_BANNER_DATA = "setBannerData";
export const SET_BANNER_DATA_ERROR = "SetBannerDataError";
export const SET_BANNER_CURRENT_PAGE = "setBannerCurrentPage";
export const SET_BANNER_PARENT_PAGE = "setBannerParentPage";


// contact mutation
export const SET_SETTING_DATA = "setSettingData";
export const SET_SETTING_DATA_ERROR = "SetSettingDataError";
export const SET_SETTING_CURRENT_PAGE = "setSettingCurrentPage";
export const SET_SETTING_PARENT_PAGE = "setSettingParentPage";



// contact mutation
export const SET_CONTACT_DATA = "setContactData";
export const SET_CONTACT_DATA_ERROR = "SetContactDataError";
export const SET_CONTACT_CURRENT_PAGE = "setContactCurrentPage";
export const SET_CONTACT_PARENT_PAGE = "setContactParentPage";


// news mutation
export const SET_NEWS_DATA = "setNewsData";
export const SET_NEWS_DATA_ERROR = "SetNewsDataError";
export const SET_NEWS_CURRENT_PAGE = "setNewsCurrentPage";
export const SET_NEWS_PARENT_PAGE = "setNewsParentPage";


// MENU mutation

export const SET_MAIN_MENU = "setMainMenu";
export const SET_MAIN_MENU_ERROR = "setMainMenuError";
export const SET_MENU_LOADED = "setMenuLoaded";
// rtMENU mutation

export const SET_RMAIN_MENU = "setRmainMenu";
export const SET_RMAIN_MENU_ERROR = "setRmainMenuError";
export const SET_RMENU_LOADED = "setRmenuLoaded";

// social icon mutation

export const SET_SOCIAL = "setSocial";
export const SET_SOCIAL_ERROR = "setSocialError";
export const SET_SOCIAL_LOADED = "setSocialLoaded";

// setting icon mutation

export const SET_SETTING = "setSetting";
export const SET_SETTING_ERROR = "setSettingError";
export const SET_SETTING_LOADED = "setSettingLoaded";

// global icon mutation

export const SET_GLOBAL = "setGlobal";
export const SET_GLOBAL_ERROR = "setGlobalError";
export const SET_GLOBAL_LOADED = "setGlobalLoaded";

// tab mutation
export const SET_TAB_DATA = "setTabData";
export const SET_TAB_DATA_ERROR = "SetTabDataError";
export const SET_TAB_CURRENT_PAGE = "setTabCurrentPage";
export const SET_TAB_PARENT_PAGE = "setTabParentPage";

// tab mutation
export const SET_GALLERY = "setGalleryData";
export const SET_GALLERY_ERROR = "SetGalleryDataError";
export const SET_GALLERY_CURRENT_PAGE = "setGalleryCurrentPage";
export const SET_GALLERY_PARENT_PAGE = "setGalleryParentPage";